<script setup lang="ts">
  import { usePageStore } from '@/stores/page'
  import SidebarSearch from './sidebar/sidebar-search.vue'

  const page = usePageStore()

  const emit = defineEmits<{
    (e: 'toggleSidebar'): void,
    (e: 'openSearch'): void,
  }>()
</script>

<!--
Mobile: Hamburger Menu
Desktop: Sidebar
-->

<template>
  <nav class="navbar">
    <div class="container px-container">
      <div class="navbar-content">
        <div class="lg:hidden">
          <app-button
            class="text-gray-500 navbar-button aspect-square px-0!"
            @click="emit('toggleSidebar')">
            <fa-icon icon="i-fas-bars" />
          </app-button>
        </div>

        <div class="flex-1">
          {{ page.title }}
        </div>

        <div class="hidden lg:block">
          <sidebar-search @open-search="emit('openSearch')" />
        </div>
      </div>
    </div>
  </nav>
</template>

<style>
  @reference "@/assets/styles/main.css";

  :root {
    --navbar-height: 4rem; /* 4rem 64px */
  }

  .navbar {
    @apply fixed top-0 right-0 z-10 flex items-center;
    @apply border-b bg-white;
    @apply left-0 lg:left-[calc(var(--sidebar-width))]!;
    @apply h-(--navbar-height);
    @apply transition-all duration-500;
  }

  .navbar-content {
    @apply flex w-full items-center gap-4;
  }

  .navbar-button {
    @apply flex-center;
  }
</style>
